import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReportService } from 'src/app/service/report.service';
import { GSMConfigurationService } from 'src/app/Service/gsmconfiguration.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GenericValidator } from 'src/app/validation/general-validation';
import { AuthService } from 'src/app/service/auth.service';

@Component({
  selector: 'app-reportdatapopup',
  templateUrl: './reportdatapopup.component.html'
})
export class ReportdatapopupComponent implements OnInit {
  RegisterData: any[] = [];
  ReportDataList = [];
  ReportId: number = 0;
  meterMasterID: number = 0;
  CompanyId: number = 0;
  Action: string = '';
  errorMsg: string = '';
  SiteName: string = '';
  PanelName: string = '';
  meterId: string = '';
  successMsg: string = '';
  reportDataForm: FormGroup;
  displayMessage: { [key: string]: string } = {};
  private genericValidator: GenericValidator;
  private validationMessages: { [key: string]: { [key: string]: string } };
  selectedData: any = []
  ReportNameflag: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private reportservice: ReportService, public dialogRef: MatDialogRef<ReportdatapopupComponent>, private GSMConfigService: GSMConfigurationService, private form: FormBuilder, private authService: AuthService) {
    dialogRef.disableClose = true;
    if (data && data.Action) {
      this.Action = data.Action;
    }

    if (data && data.ReportId) {
      this.ReportId = data.ReportId;
    }

    if (data && data.meterMasterID) {
      this.meterMasterID = data.meterMasterID;
    }

    if (data && data.CompanyId) {
      this.CompanyId = data.CompanyId;
    }
    if (data && data.ReportName == "Daily Report") {
      this.ReportNameflag = true
    }

    // Raise Validation message
    this.authService.getValidationMessage().subscribe(resp => {
      this.validationMessages = resp.reportDataForm;
      this.genericValidator = new GenericValidator(this.validationMessages);
    });
  }

  ngOnInit(): void {

    this.reportDataForm = this.form.group({
      RegisterDataId: ['', [Validators.required]]
    });

    this.GetRegisterList(this.meterMasterID);
    this.GetReportConfigData();

    // Call service for validation on valu change
    this.reportDataForm.valueChanges.subscribe(
      value => this.displayMessage = this.genericValidator.processMessages(this.reportDataForm)
    );
  }

  // Get Report Config Data
  GetReportConfigData() {
    this.reportservice.GetReportConfigChildData(this.ReportId, this.meterMasterID).subscribe(
      (result) => {
        if (result) {
          this.SiteName = result.CompSiteName;
          this.PanelName = result.CompPanelName;
          this.meterId = result.EnergymeterID;
          this.ReportDataList = result.listRegisterdata;

          this.ReportDataList
            .filter(item => item.IsForTotal === true)
            .forEach(item => {
              this.selectedData.push(item.RegisterDataId);
            });
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  // Close Icon event
  Close() {
    this.dialogRef.close();
  }

  // Get Register Data
  GetRegisterList(id) {
    if (id != null) {
      this.GSMConfigService.GetRegisterdata(id, 'Y', 'N', 'Y').subscribe(
        (result) => {
          if (result.listRegisterdata != null) {
            this.RegisterData = result.listRegisterdata;
          }
        },
        (error) => {
          this.errorMsg = error;
        }
      );
    }
  }

  // Add Report Data
  AddReportData() {
    this.ReportDataList = this.ReportDataList || [];
    var existdata = this.ReportDataList.filter(r => r.RegisterDataId === +this.reportDataForm.value.RegisterDataId);
    if (existdata && existdata.length > 0) {
      this.errorMsg = 'Register Name is already Exist!!';
      return false;
    }
    var SeqId;
    if (this.ReportDataList.length > 0) {
      SeqId = this.ReportDataList[this.ReportDataList.length - 1].SeqId;
    }
    else {
      SeqId = 0;
    }
    if (this.reportDataForm.value.RegisterDataId > 0) {
      var reportdata = this.RegisterData.filter(s => s.RegisterDataId == this.reportDataForm.value.RegisterDataId)[0];

      this.ReportDataList.push({
        SeqId: ++SeqId,
        RegisterName: reportdata.RegisterName,
        TagId: reportdata.TagId,
        RegisterDataId: reportdata.RegisterDataId,
        ReportId: this.ReportId,
        IsForTotal: false
      });
      this.errorMsg = ''
    }
    else {
      this.errorMsg = 'Please select Register Name';
      return false;
    }
  }

  // Delete Data from Locally
  DeleteReportData(RegisterDataId) {
    this.successMsg = '';
    this.errorMsg = '';
    let index = this.ReportDataList.findIndex(x => x.RegisterDataId === RegisterDataId);
    this.ReportDataList.splice(index, 1);
  }

  // Take 1 step up and down report data
  UpDownReportData(index, Type) {
    if (Type == 'UP') {
      [this.ReportDataList[index], this.ReportDataList[index - 1]] = [this.ReportDataList[index - 1], this.ReportDataList[index]];
    }
    else {
      [this.ReportDataList[index], this.ReportDataList[index + 1]] = [this.ReportDataList[index + 1], this.ReportDataList[index]];
    }
  }

  onCheckboxChange(element: any, isChecked: boolean) {
    if (!this.selectedData.includes(element) && isChecked) {
      this.selectedData.push(element);
    }
    else if (this.selectedData.includes(element) && !isChecked) {
      const indexToRemove = this.selectedData.indexOf(element);
      if (indexToRemove !== -1) {
        this.selectedData.splice(indexToRemove, 1);
      }
    }
  }
  SaveReportData() {
    this.errorMsg = '';
    this.successMsg = '';
    this.ReportDataList.forEach((item: any) =>
      item.IsForTotal = this.selectedData.includes(item.RegisterDataId)
    );
    let reqparam = {
      listRegisterdata: this.ReportDataList,
      IsForChildData: 'Y'
    };
    this.reportservice.SaveReportConfigData(reqparam).subscribe(
      (result) => {
        if (result = 'success') {
          this.successMsg = 'Report data saved successfully';
          this.errorMsg = ''
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }
}
